import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { checkBrowser, initUserLanguage } from '@/hooks/navigatorHook';
import { PATH } from '@/utils/constant';
import Error from '@default/error';
import UnsuppotedBrowser from '@default/unsupported_browser';
import Intro from '@intro/intro';
import Layout from '@layout/layout';
import Project from '@project/project';

function App() {
  initUserLanguage();

  return checkBrowser() ? (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path={PATH.intro} Component={Intro} />
          <Route path={PATH.project} Component={Project} />
          <Route path="*" Component={Error} />
        </Routes>
      </Layout>
    </BrowserRouter>
  ) : (
    <Layout empty>
      <UnsuppotedBrowser />
    </Layout>
  );
}

export default App;
